import React from "react";
import { Card } from "antd";
import { Link } from "react-router-dom";
import "./style.css";
import { Button } from "../../../../../components";

const ForumCard = ({ bgColor, title, members, image }) => {
  return (
    <>
      <Card
        className="shadow-lg forum-card 2xl:w-56 xl:w-52 w-60"
        style={{
          borderRadius: 10,
          overflow: "hidden",
          background: "#fff",
        }}
      >
        <div style={{ height: "145px", background: `${bgColor}` }}></div>
        <div className="w-full flex justify-center">
          <img src={image} style={{ marginTop: "-50px", maxHeight: 100 }} width={100} />
        </div>
        <div
          style={{ height: "130px" }}
          className="flex flex-col justify-center items-center px-5"
        >
          <h5 className="font-bold text-sm 2xl:text-xl mt-5 text-center">{title}</h5>
          <p>{members}</p>
          <Link to={`/forum/${title}`} className="w-full">
            <Button
              type="primary"
              shape="round"
              className="mt-5 mb-5 rounded-button button-primary w-full"
              title="Join"
            />
          </Link>
        </div>
      </Card>
    </>
  );
};

export default ForumCard;
